module.exports = __webpack_public_path__ + "img/podpis-fkbv.012f13f3.png";